import { store } from '../store'
import { loggerNamespace } from '../lib/Logger'
import { create as createConfig, TDynamicCatalogConfig } from '../models/DynamicCatalogConfig'
import { create as createItem, TDynamicCatalogItem } from '../models/DynamicCatalogItem'
import { AbstractCatalogService, TCatalogType } from './AbstractCatalogService'

export class DynamicCatalogService extends AbstractCatalogService<TDynamicCatalogConfig, TDynamicCatalogItem>{
  public type: TCatalogType = 'dynamic'
  public store = store.dynamicCatalog
  protected logger = loggerNamespace('DynamicCatalogService')
  protected createConfig = createConfig
  protected createItem = createItem
}

const dynamicCatalogService = new DynamicCatalogService()
export { dynamicCatalogService }
